import { FC, Fragment, useReducer } from 'react';

import { Plus } from 'lucide-react';
import { toast } from 'sonner';
import useSWRMutation from 'swr/mutation';

import Button from '@mui/material/Button';

import { TelegramAuthBotFormDialog } from '../telegramAuthBotFormDialog/TelegramAuthBotFormDialog';

import { telegramAuthBotService } from 'v2/api/telegramAuthBotService';
import { TelegramAuthBotRequestBody } from 'v2/types/TelegramAuthBotModel';
import { handleHttpError } from 'v2/utils';

interface CreateTelegramAuthBotButtonProps {
  onSuccess: VoidFunction;
  domainId: string;
}

export const CreateTelegramAuthBotButton: FC<CreateTelegramAuthBotButtonProps> = ({ onSuccess, domainId }) => {
  const [isOpen, setOpen] = useReducer((state) => !state, false);

  const { trigger, isMutating } = useSWRMutation('createTelegramAuthBot', telegramAuthBotService.createBot, {
    onSuccess: () => {
      onSuccess();
      toast.success('Telegram auth bot has been created successfully');
      setOpen();
    },
    onError: handleHttpError,
  });

  const handleSubmit = (values: TelegramAuthBotRequestBody) => {
    trigger(values);
  };

  return (
    <Fragment>
      <Button onClick={setOpen} startIcon={<Plus />} variant="contained" size="small">
        Add Bot
      </Button>

      <TelegramAuthBotFormDialog
        title="Add Telegram Auth Bot"
        isOpen={isOpen}
        onClose={setOpen}
        domainId={domainId}
        isSubmitting={isMutating}
        onSubmit={handleSubmit}
      />
    </Fragment>
  );
};
